import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

import {
   allSamLabReport,
   deleteSamLabReport,
   fetchSamLabReport,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddItem from './component/addform';
import ViewItem from './component/viewform';
import EditForm from './component/editform';

class samlabreport extends Component {

   constructor(props) {

      super(props);
      this.confirmationDialog = React.createRef();
      this.state = {
         viewdiv: true,
         adddiv: false,
         editdiv: false,
         editdiv2: false,
         seldate: '',
         student: '',
         eid: '',
      };

      this.onBackSection = this.onBackSection.bind(this);
      this.deleteForm = this.deleteForm.bind(this);
   }

   UNSAFE_componentWillMount() {
      this.props.allSamLabReport();
   }

   onAddSession() {
      this.setState({
         viewdiv: false,
         ditdiv: false,
         adddiv: true,
      });
   }

   onBackSection() {
      this.setState({
         adddiv: false,
         editdiv: false,
         editdiv2:false,
         viewdiv: true,
      });
   }


   editAssessment(gid) {
      this.props.fetchSamLabReport(gid).then((data) => {
         var resdata = data.data;
         this.setState({
            seldate: resdata[0].gfs_date,
            student: resdata[0].gfs_userID,
            eid: resdata[0].gfsID,
         });

         this.setState({
            viewdiv: false,
            adddiv: false,
            editdiv: true,
         });

      });
   }

   editAssessment2(gid) {
      this.props.fetchSamLabReport(gid).then((data) => {
         var resdata = data.data;
         // this.setState({
         //    seldate: resdata[0].gfs_date,
         //    student: resdata[0].gfs_userID,
         //    eid: resdata[0].gfsID,
         // });

         this.setState({
            viewdiv: false,
            adddiv: false,
            editdiv: false,
            editdiv2: true,
         });

      });
   }

   deleteForm(data) {
      this.data = data;
      this.confirmationDialog.current.openDialog();
   }

   deleteDataPermanent(popupResponse) {

      if (popupResponse) {
         this.props.deleteSamLabReport(this.data);
         this.data = ""
      }
   }



   render() {
      const { match, samlabreportlist, loading } = this.props;
      const options = {
         filterType: 'dropdown',
         rowsPerPage: 50,
         rowsPerPageOptions: [50, 100, 150],
         selectableRowsHideCheckboxes: true,
      };

      const columns = [
         { name: "no", label: "NO" },
         { name: "name", label: "NAME" },
         { name: "cdate", label: "DATE" },
         { name: "action", label: "REPORT" },
         { name: "action1", label: "ACTION1" },

      ];
         const tabledata = Array.isArray(samlabreportlist) ? samlabreportlist.map((assmntval, idx) => {
         const flbtn = <a onClick={() => this.editAssessment(assmntval.tsrID)}><span className="badge badge-info" >View</span></a>;
         const editBtn = (
            <IconButton className="text-info" aria-label="edit" onClick={() => this.editAssessment2(assmntval.tsrID)}><EditOutlinedIcon/></IconButton>
         );
         const deleteBtn = (
            <IconButton
               className="text-danger"
               aria-label="Remove"
               onClick={() => this.deleteForm(assmntval.tsrID)}
            >
               <DeleteOutlineOutlinedIcon/>
            </IconButton>
         );
         return {
            no: idx + 1,
            name: assmntval.student,
            cdate: assmntval.cdate,
            action: flbtn,
            action1: (
               <div>
                  {editBtn} {deleteBtn}
               </div>
            ),

         }
      }) : [];

      return (
         <div className="saas-dashboard">
            <Helmet>
               <title>SAM LAB SESSION | {AppConfig.appTitle}</title>
               <meta name="description" content="Golf" />
            </Helmet>
            <PageTitleBar title={<IntlMessages id="sidebar.samlabreport" />} match={match} />

            {this.state.viewdiv &&
               <div className="col-sm-12 col-md-12">
                  <RctCollapsibleCard heading="List" fullBlock>
                     <MUIDataTable
                        title={<div><Button onClick={() => this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Report</Button></div>}
                        data={tabledata}
                        columns={columns}
                        options={options}
                     />
                  </RctCollapsibleCard>
               </div>
            }

            {this.state.adddiv &&
               <AddItem onClick={this.onBackSection} data={this.state}/>
            }

            {this.state.editdiv &&
               <ViewItem onClick={this.onBackSection} />
            }

            {this.state.editdiv2 &&
               <EditForm onClick={this.onBackSection} data={this.state}/>
            }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'sam lab report'}
            />

         </div>
      )
   }
}

const mapStateToProps = ({ samlabreport }) => {
   const { samlabreportlist, loading } = samlabreport;
   return { samlabreportlist, loading };
}

export default connect(mapStateToProps, {
   allSamLabReport,
   deleteSamLabReport,
   fetchSamLabReport,
})(samlabreport); 